import "./navbar.css";
import logo from "../../images/logo.png";
import React from 'react'
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { useState } from "react";

const Navbar = () => {
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const [color, setColor] = useState(false);
    const changeColor = () => {
        if(window.scrollY >= 50){
            setColor(true);
        }else{
            setColor(false);
        }
    };

    window.addEventListener("scroll", changeColor);
  return (
    <div className={color ? "header header-bg" : "header"}>
        <Link to ="/">
        <a className='nav-logo' href='#'>
          <img className='logo' src={logo} alt='My logo' />
        </a>
        </Link>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li>
                <Link to = "/">Home</Link>
            </li>
            <li>
                <Link to = "/about">About</Link>
            </li>
            <li>
                <Link to = "/services">Services</Link>
            </li>
            <li>
                <Link to = "/projects">Projects</Link>
            </li>
            <li>
                <Link to = "/contact">Contact</Link>
            </li>
        </ul>
        <div className="hamburger" onClick={handleClick}>
            {click ? (<FaTimes size={20} style={{color: "#fff"}}/>) : (<FaBars size={20} style={{color: "#fff"}}/>)}
            
            
        </div>
    </div>
  )
}

export default Navbar;